<template>
    <div :class="[appType]">
        <div class="summary-background">
            <a class="thank-you-site-logo" :href="pageUrl" target="_blank">
                <img v-if="'AP' === systemConst.SYSTEM_SHORTCUT" class="logo-radius" :src="require(`../../assets/images/${systemConst.SUMMARY_LOGO_NAME}`)" alt="logo" title="logo"/>
                <img v-else class="logo" :src="require(`../../assets/images/${systemConst.SUMMARY_LOGO_NAME}`)" alt="logo" title="logo"/>
            </a>
            <div class="podziekowanie-block">
                <h2>Dziękujemy</h2>
                <div v-html="systemConst.THANK_YOU_TEXT_FIRST"></div>
                <br>
                <div v-html="systemConst.THANK_YOU_TEXT_SECOND"></div>

                <a class="facebook-share" href="#" @click="share">
                    Udostępnij na FB
                </a>
            </div>
        </div>
        <SummaryFooter />
    </div>
</template>
<script>
import GtmTransaction from '../../mixins/GtmTransaction'
import systemConst from '@SYSTEM_CONSTANTS'
import SummaryFooter from '../organisms/SummaryFooter'

export default {
    name: 'ThankYouPage',
    mixins: [GtmTransaction],
    data () {
        return {
            appType: process.env.VUE_APP_SYSTEM,
            pageUrl: process.env.VUE_APP_PAGE_URL,
            imagesPath: process.env.VUE_APP_DEFAULT_PAYMENT_IMAGES_PATH,
            systemConst
        }
    },
    components: {
        SummaryFooter
    },
    methods: {
        share () {
            window.open(systemConst.FB_SHARE_LINK, 'newwindow', 'width=560, height=510 ')
            return false
        }
    }
}
</script>
